<template>
  <b-container class="py-4">
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <b-row>
      <b-col cols="auto" class="mr-auto">
        <h1 class="mb-3">Kalendar</h1>
      </b-col>
      <b-col cols="auto">
        <AddEvent ref="add_event" />
      </b-col>
    </b-row>
    <FullCalendar ref="full_calendar" :options="calendarOptions" />
    <ShowEvent ref="show_event" v-on:event-edit="eventEdit" />
    <EditEvent ref="edit_event" v-on:reset-event="resetEvent" />
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddEvent from "@/components/calendar/AddEvent";
import ShowEvent from "@/components/calendar/ShowEvent";
import EditEvent from "@/components/calendar/EditEvent";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import srLocale from "@fullcalendar/core/locales/sr";
import moment from "moment";

export default {
  components: {
    FullCalendar,
    AddEvent,
    ShowEvent,
    EditEvent
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        locale: srLocale,
        eventClick: this.handleEventClick,
        events: this.events,
        forceEventDuration: false,
        displayEventTime: false,
        defaultAllDay: false,
        dayMaxEventRows: 4
      }
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [
      {
        html: "<i class='fas fa-home'></i>",
        to: { name: "home" }
      },
      {
        text: this.project_title,
        to: { name: "project" }
      },
      {
        text: "Kalendar",
        to: { name: "calendar" },
        active: true
      }
    ]);
    this.getEvents()
      .then(res => {
        //console.log(this.events);
        this.calendarOptions.events = this.events;
      })
      .catch();
  },
  computed: {
    ...mapGetters({
      events: "calendar/events",
      breadcrumbs: "breadcrumbs",
      project_title: "project/title"
    })
  },
  methods: {
    ...mapMutations({ setCurrentEvent: "calendar/setCurrentEvent" }),
    ...mapActions({
      getEvents: "calendar/fetchEvents",
      deleteEvent: "calendar/deleteEvent"
    }),
    handleEventClick(e) {
      //console.log(e.event);
      const evt = {
        id: e.event.id,
        title: e.event.title,
        description: e.event.extendedProps.description,
        start: moment(e.event.start).format("YYYY-MM-DD"),
        end: moment(e.event.end).format("YYYY-MM-DD"),
        user_id: e.event.extendedProps.user_id,
        location: e.event.extendedProps.location,
        project: e.event.extendedProps.project,
        organization: e.event.extendedProps.organization
      };
      this.setCurrentEvent(evt);
      this.$refs.show_event.show();
    },
    resetEvent() {
      this.event_data = {
        title: "",
        description: "",
        start: null,
        end: null
      };
    },
    eventEdit() {
      this.$refs.edit_event.show();
    }
  }
};
</script>

<style>
</style>